<template>
    <VJoyPanel>
        <template #panel-title>
            {{ $t('projectclient.projectview.details.additional.notes.title') }}
        </template>
        <template #panel-body>
            <div class="project-details-additional-notes">
                <ShowMoreTextContent :lines="3">
                    <template #text-content>
                        <div>{{ additionalNotes }}</div>
                    </template>
                </ShowMoreTextContent>
            </div>
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {escapeHtml} from '@malt/sanitize';
    import {VJoyPanel} from '@maltjoy/core-vue';
    import {useProjectInformationStore} from '@/common/stores';
    import {ShowMoreTextContent} from '@/common/ui';

    const projectInformationStore = useProjectInformationStore();
    const {projectInformation} = storeToRefs(projectInformationStore);

    const additionalNotes = computed(() => {
        return escapeHtml(projectInformation.value.additionalNotes);
    });
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint' as joy;

    .project-details-additional-notes {
        @include joy.getFontBySize(primary-300);
    }
</style>
